import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHomeProducts } from "../../../api/queries/homeQueries";
import { TicketBox } from "../../../components/box/TicketBox";
import { UI } from "../../../config/ui";
import { useTranslationEx } from "../../../hooks/useTranslationEx";
import {
  icSwiperNextArrow,
  icSwiperPrevArrow,
} from "../../../components/image/image-src";

const RecommendTicketSwiper: React.FC = () => {
  const { handleSlideChange, products } = useHomeProducts("TICKET", "tickets");
  return (
    <TicketBoxSwiper
      products={products}
      handleSlideChange={handleSlideChange}
    />
  );
};

export const TicketBoxSwiper: React.FC<{
  products: ProductBaseResponse[];
  handleSlideChange?: (swiper: any) => void;
}> = ({ products, handleSlideChange = () => {} }) => {
  const { t2 } = useTranslationEx({});
  return (
    <div className="relative">
      <Swiper
        modules={[Navigation]}
        onSlideChange={handleSlideChange}
        slidesPerView={1.8}
        spaceBetween={12}
        breakpoints={{
          [UI.sm]: {
            slidesPerView: 3,
            spaceBetween: 22,
          },
          [UI.lg]: {
            slidesPerView: 4,
            spaceBetween: 22,
          },
        }}
        navigation={{
          nextEl: "#rcmd-ticket-next",
          prevEl: "#rcmd-ticket-prev",
        }}
        className="-mr-4 pr-4 sm:mr-0 sm:pr-0"
      >
        {products.map((ticket, index) => (
          <SwiperSlide key={index}>
            <TicketBox
              className="aspect-[274/300]"
              product={{
                ...ticket,
                name: t2(ticket.name),
              }}
              cdnParams={{
                format: "webp",
                width: 274,
                height: 300,
                fit: "cover",
                quality: 70,
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="swiper-button-prev" id="rcmd-ticket-prev">
        <img src={icSwiperPrevArrow} alt="" />
      </div>
      <div className="swiper-button-next" id="rcmd-ticket-next">
        <img src={icSwiperNextArrow} alt="" />
      </div>
    </div>
  );
};
export default RecommendTicketSwiper;
